var React = require('react');

function Link (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_902","data-name":"Group 902","transform":"translate(10.104 0.706) rotate(42)"},[React.createElement("path",{"id":"Path_1012","data-name":"Path 1012","d":"M4.55,2.632V5.524A2.427,2.427,0,0,1,2.4,8.156H2.147A2.427,2.427,0,0,1,0,5.524V2.632C0,0,2.009,0,3.194,0h.257","transform":"translate(0 5.889)","fill":"none","stroke":"#949494","strokeMiterlimit":"10","strokeWidth":"1","key":0}),React.createElement("path",{"id":"Path_1013","data-name":"Path 1013","d":"M0,5.524V2.632A2.427,2.427,0,0,1,2.147,0H2.4A2.427,2.427,0,0,1,4.55,2.632V5.524c0,2.632-2.009,2.632-3.194,2.632H1.1","transform":"translate(0)","fill":"none","stroke":"#949494","strokeMiterlimit":"10","strokeWidth":"1","key":1})]));
}

Link.defaultProps = {"width":"14.192","height":"14.895","viewBox":"0 0 14.192 14.895"};

module.exports = Link;

Link.default = Link;
